import { jsxs, jsx } from "react/jsx-runtime";
const IconHeartSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 21c-.148 0-.297-.033-.434-.099-3.959-1.906-9.709-7.533-9.709-12.012C1.857 5.642 4.562 3 7.886 3c1.538 0 3.008.58 4.114 1.589A6.114 6.114 0 0 1 16.114 3c3.324 0 6.029 2.642 6.029 5.889 0 4.48-5.75 10.106-9.71 12.012A1.005 1.005 0 0 1 12 21ZM7.886 5C5.664 5 3.857 6.744 3.857 8.889c0 3.382 4.71 8.137 8.143 9.988 3.433-1.85 8.143-6.606 8.143-9.988C20.143 6.744 18.336 5 16.114 5a4.079 4.079 0 0 0-3.303 1.669c-.377.52-1.245.52-1.622 0A4.079 4.079 0 0 0 7.886 5Z" })
    ]
  }
);
export {
  IconHeartSvg
};
